import {
	styled,
} from '@mui/material'

import {
	HStack,
} from '@/shared/components/stack'
import type {
	StackProps,
} from '@/shared/components/stack/stack/stack.types'

export const HStackRoot = styled(HStack)<StackProps>`
    background-color: var(--surface-container-color);
    border: var(--outline-base);
    border-radius: var(--border-radius-m);
    padding: var(--base-spacing-2);
`
